import { Http, RequestOptions, Headers } from "@angular/http";
import { Storage } from "@ionic/storage";
import { TranslateService } from "@ngx-translate/core";
import { LoginPage } from "./../login/login";
import { Component } from "@angular/core";
import { IonicPage, NavController, LoadingController } from "ionic-angular";
import { QRScanner, QRScannerStatus } from "@ionic-native/qr-scanner";
import { ServiceProvider } from "../../providers/service/service";
import { LoginSyncPlatformPage } from "../login-sync-platform/login-sync-platform";

@IonicPage()
@Component({
  selector: "page-login-qr",
  templateUrl: "login-qr.html",
})
export class LoginQrPage {
  scanSub: any;

  constructor(
    public navCtrl: NavController,
    private qrScanner: QRScanner,
    private loadingCtrl: LoadingController,
    private storage: Storage,
    private translateService: TranslateService,
    private services: ServiceProvider,
    private http: Http
  ) {}

  ionViewDidLoad() {
    this.qrScanner
      .prepare()
      .then((status: QRScannerStatus) => {
        if (status.authorized) {
          // console.log('Camera Permission Given');
          this.scanSub = this.qrScanner.scan().subscribe((result: string) => {
            //  console.log('Scanned something', text);

            var text = JSON.parse(result);

            let loader = this.loadingCtrl.create({
              // content: "Loading Please Wait...",
              duration: 3000,
            });
            loader.present();

            var link = this.services.URLAuthen;

            var postData = JSON.stringify({
              grant_type: "password",
              username: text.username, //'admin@api.loc'
              password: text.password, //123123123
              client_id: "the-plaza",
              client_secret: "onHtIz4owSNWgcEd7JELw2X-0vG8c02w",
              scope: "custom",
            });

            this.http
              .post(link, postData, this.services.getHeaderAuthen())
              .map((res) => res.json())
              .subscribe(
                (data) => {
                  this.storage.set("token", data.access_token);
                  this.storage.set("roundGame", 1);
                  this.storage.set("stepGame", "syncPlatform");
                  var link = this.services.URLUserInfo;
                  var headers = new Headers();
                  headers.append("Accept", "application/json");
                  headers.append(
                    "Authorization",
                    "Bearer " + data.access_token
                  );
                  const requestOptions = new RequestOptions({
                    headers: headers,
                  });

                  this.http
                    .get(link, requestOptions)
                    .map((res) => res.json())
                    .subscribe(
                      (res) => {
                        this.storage.set("info", res);
                        this.storage.set("theme", res.section.theme_id);
                        this.navCtrl.setRoot(LoginSyncPlatformPage);
                        loader.dismiss();
                      },
                      (error) => {
                        var response = JSON.parse(error._body);
                        loader.dismiss();
                        this.translateService
                          .get(response.message)
                          .subscribe((value) => {
                            this.services.presentToast(value);
                          });
                      }
                    );
                },
                (error) => {
                  var response = JSON.parse(error._body);
                  loader.dismiss();
                  this.translateService
                    .get(response.message)
                    .subscribe((value) => {
                      this.services.presentToast(value);
                    });
                }
              );

            this.qrScanner.hide();
            this.scanSub.unsubscribe();
          });

          this.qrScanner.show();
        } else if (status.denied) {
          console.log("Camera permission denied");
        } else {
          console.log("Permission denied for this runtime.");
        }
      })
      .catch((e: any) => console.log("Error is", e));
  }

  backPage() {
    this.navCtrl.push(LoginPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/login-qr/login-qr.ts